import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { AutoComplete, message, Col } from 'antd';
import { getAppConfig } from '@send-legacy-utils/appConfig';
import Script from 'react-load-script';
import axios from 'axios';

const appConfig = getAppConfig();
const AUTOCOMPLETE_URL = 'https://places.googleapis.com/v1/places';

const getAddressFromGoogleApi = (address) => {
  if (address) {
    const data = {};
    for (let i = 0, iLen = address.addressComponents.length; i < iLen; i++) {
      if (address.addressComponents[i].types.includes('route')) {
        data.streetAddressName = address.addressComponents[i].longText;
        appConfig.streetTypes.forEach((element) => {
          if (address.addressComponents[i].longText.includes(element[0])) {
            // eslint-disable-next-line prefer-destructuring
            data.streetAddressType = element[0];
            data.streetAddressName = address.addressComponents[i].longText.replace(element[0], '').trim();
          }
        });
      }
      if (address.addressComponents[i].types.includes('street_number')) {
        data.streetAddressNumber = address.addressComponents[i].shortText;
      }
      if (address.addressComponents[i].types.includes('locality')) {
        data.city = address.addressComponents[i].shortText;
      }
      if (address.addressComponents[i].types.includes('administrative_area_level_1')) {
        data.state = address.addressComponents[i].shortText;
      }
      if (address.addressComponents[i].types.includes('postal_code')) {
        data.postcode = address.addressComponents[i].shortText;
      }
      if (address.addressComponents[i].types.includes('country')) {
        data.country = address.addressComponents[i].longText;
      }
    }
    return data;
  }
  return {};
};

// REVIEW THIS FILE, we are too tight to the google api.
// THIS FILE MUST BE REFACTORED!!!!
function AddressAutoComplete(props) {
  const sm = props.sm ? props.sm : props.span;
  const md = props.md ? props.md : sm;
  const { Option } = AutoComplete;
  const [results, setResults] = useState([]);
  const [resultsFeedback, setResultsFeedback] = useState('No results found');
  const { onAddressChanged } = props;

  let timer = null;

  const initService = (textInput) => {
    axios
      .post(
        `${AUTOCOMPLETE_URL}:autocomplete`,
        {
          input: textInput, // User's typed input
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': process.env.GOOGLE_API_KEY,
          },
        },
      )
      .then((response) => {
        setResults(response.data.suggestions);
      })
      .catch((error) => {
        message.error('Failed to get autocomplete suggestions');
      });
  };

  const changeFilter = (value) => {
    clearTimeout(timer);
    setResultsFeedback('Searching...');
    timer = setTimeout(() => initService(value.trim()), 1000);
  };

  const getDetails = (placeId) => {
    axios
      .get(`${AUTOCOMPLETE_URL}/${placeId}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Goog-Api-Key': process.env.GOOGLE_API_KEY,
          'X-Goog-FieldMask': 'id,addressComponents',
        },
      })
      .then((response) => {
        const place = response.data;
        props.setter(place);
        const address = getAddressFromGoogleApi(place);
        onAddressChanged(address);
      })
      .catch((error) => {
        message.error('Failed to get place details');
      });
  };

  const options = results
    ?.filter(({ placePrediction }) => !!placePrediction.placeId)
    .map(({ placePrediction }) => (
      <Option key={placePrediction.placeId} label={placePrediction.text.text}>
        {placePrediction.text.text}
      </Option>
    ));

  return (
    <Col span={props.span} md={md} sm={sm}>
      <AutoComplete
        data-testid="addressSearch"
        onChange={changeFilter}
        dataSource={options}
        resultsFeedback={resultsFeedback}
        onSelect={getDetails}
        placeholder={props.label}
        style={{ width: '100%' }}
      />
    </Col>
  );
}

AddressAutoComplete.propTypes = {
  label: PropTypes.string,
  span: PropTypes.number,
  md: PropTypes.number,
  sm: PropTypes.number,
  setter: PropTypes.func,
  onAddressChanged: PropTypes.func,
};

AddressAutoComplete.defaultProps = {
  span: 24,
  sm: 0,
  md: 0,
  label: 'Search for an address',
  setter: () => {},
  onAddressChanged: () => {},
};

export default AddressAutoComplete;
